export default {
  "foot": {
    "title": "Jogadores da Century Games",
    "p1": "Insira o seu ID de usuário e pague pela recarga. O valor será atualizado diretamente na sua conta associada. Se não aparecer, favor recarregar o jogo ou entrar em contato com o suporte ao cliente, caso necessário.",
    "p2": "Se você tiver alguma dúvida, não hesite em entrar em contato com o suporte ao cliente. Obrigado pelo seu apoio!",
    "copyright": "© Copyright 2024 Century Games.",
    "service": "Termos de Serviço",
    "policy": "Política de Privacidade",
    "descriptionTitle": "Como Funciona?"
  },
  "accept": {
    "title": "Este site utiliza cookies para melhorar a sua experiência de navegação. Leia nossa <a href=\"https://www.centurygames.com/privacy-policy/\" style=\"color: #58a8a5;\">Política de Privacidade</a> para obter mais informações sobre o que coletamos no nosso site. Ao continuar a utilizar este site, você concorda que podemos armazenar e acessar cookies no seu dispositivo.",
    "decline": "Discordar",
    "accept": "Aceitar"
  },
  "game": {
    "inapptext": "Ou Entre via Jogo",
    "loginfail": "Falha ao Entrar",
    "logintip": "Se o jogo não for autorizado, atualize o jogo para a versão mais recente ou tente outro navegador.",
    "reloadmsg": "Por favor, toque no botão 'Recarregar' para obter o resultado do login.",
    "reload": "Recarregar",
    "appnotice": "Se quiser fazer login através do aplicativo do jogo, use um navegador externo para abrir a loja.",
    "changeaccount": "Tem certeza de que deseja sair da sua conta?",
    "login": "Conectar",
    "notice": "Aviso",
    "confirm": "Confirmar",
    "loginuserid": "ID do Usuário",
    "palceholder": "Inserir ID do Usuário",
    "okbtn": "OK",
    "loginbtn": "Login pelo Jogo",
    "changebtn": "Ou faça o Login com o ID de Usuário",
    "useTitle": "CONTA",
    "checkBtn": "Verificar",
    "findid": "Não foi possível encontrar o seu ID de usuário?",
    "checktext": "É normalmente encontrado nas configurações, toque no ponto de interrogação para obter mais informações.",
    "username": "Apelido:",
    "userId": "ID do Usuário :",
    "packageTitle": "VALOR DA RECARGA",
    "edit": "Editar",
    "paymentTitle": "FORMA DE PAGAMENTO",
    "total": "Total",
    "goPay": "Pagar Agora",
    "noSelectPackageTips": "Você não selecionou nenhum valor",
    "payFail": "O PAGAMENTO FALHOU",
    "camelPayfail": "O Pagamento Falhou",
    "payFailTips1": "Entre em contato com o Suporte ao Cliente do Adyen",
    "payFailTips2": "Entre em contato com o Suporte ao Cliente do Paypal",
    "paySuccess": "PAGAMENTO BEM SUCEDIDO",
    "paySuccessTips2": "Recarregue o jogo antes de entrar em contato com o Suporte ao Cliente por não receber a sua compra!",
    "camelPaySuccess": "Pagamento Bem Sucedido",
    "transactionId": "ID da Transação",
    "paySuccessTips": "A entrega do item pode demorar um pouco, aguarde",
    "deliveryFail": "FALHA NA ENTREGA",
    "deliveryFailTips": "Entre em contato com o Suporte ao Cliente",
    "orderTitle": "Seu Resumo do Pedido",
    "paidWith": "Forma de Pagamento",
    "orderID": "ID da Transação",
    "payStatus": "Status do Pagamento",
    "orderTotal": "Preço Total",
    "transactionDate": "Data da Transação",
    "goOnPay": "Comprar Novamente",
    "getInvoice": "Recibo",
    "camelDeliveryFail": "Falha de Entrega",
    "confirmOrder": "CONFIRMAÇÃO DO PEDIDO",
    "confirmFollow": "Por favor confirme o seguinte:",
    "nickname": "Apelido",
    "packageName": "Itens",
    "totalPayment": "Preço Total",
    "confirmPayWith": "Forma de Pagamento",
    "confirmAndGoOn": "Confirmar para prosseguir com o pagamento",
    "orderCancel": "Cancelar",
    "getInvoiceTitle": "ENVIAR VIA E-MAIL",
    "getInvoiceTips": "Se desejar receber o recibo por e-mail, insira um endereço de e-mail.",
    "getInvoiceTips1": "Digitar o seu email para receber o recibo",
    "getInvoiceTips2": "Concordar com a coleta e armazenamento do seu endereço de e-mail.",
    "getInvoiceTips3": "Concordar em receber e-mails sobre descontos, promoções e muito mais sobre nossos jogos por e-mail.",
    "invoiceSend": "Enviar",
    "sendSuccess": "E-mail do recibo Enviado",
    "id404": "ID do Usuário não Encontrado",
    "packageLoadingText": "Atualizando Itens da Loja...",
    "taxTips": "O preço inclui impostos",
    "adyenTips": "O serviço de pagamento é fornecido pela Adyen, que opera sob licença bancária e é supervisionada pelo Banco Central Holandês. Se você tiver alguma dúvida sobre suas certificações, consulte <a href=\"https://www.adyen.com/platform/certifications\">https://www.adyen.com/platform/certifications</a>. Para saber como eles protegem seus dados, consulte <a href=\"https://www.adyen.com/policies-and-disclaimer/privacy-policy\">https://www.adyen.com/policies-and -isenção de responsabilidade/política de privacidade</a>.",
    "paypalTips": "O serviço de pagamento é fornecido pelo PayPal. Para saber como eles protegem seus dados, consulte <a href=\"https://www.paypal.com/c2/webapps/mpp/ua/privacy-full\">https://www.paypal.com/c2 /webapps/mpp/ua/privacy-full</a>",
    "switchCountryTips": "Seu país/região preferido é ${servercountry}. Gostaria de mudar de país e moeda?",
    "paypalBtn": "Pagar agora com Cartão",
    "paypalOr": "Ou",
    "paypalCard1": "Nome do titular do cartão (opcional)",
    "paypalCard2": "Número do Cartão",
    "checkUserID": "Link",
    "success": "SUCESSO",
    "changeCurrencyContent": "Gostaria de mudar a região e a moeda para corresponder à configuração do jogo: ${servercountry}？",
    "productDescription": "Notas da Fazenda são equivalentes a dinheiro que podem ser usados ​​para comprar quaisquer pacotes e ofertas no jogo.",
    "payButton": "PAGAR",
    "userIdNotice": "Por favor, insira o seu ID de Usuário para vincular a sua conta de jogo primeiro",
    "account": "Conta",
    "card": "Cartão",
    "notification": "Insira seu ID de Usuário para vincular a sua conta, selecione os itens desejados e pague com o método de pagamento de sua preferência. Após recarregar o jogo, os itens comprados irão aparecer na sua conta, prontos para uso.\r\n\r\nSe você tiver alguma dúvida, se sinta à vontade para entrar em contato com o suporte ao cliente no jogo.",
    "rongluRank": "Nível da Fornalha:",
    "tips": "Como usar?",
    "checkTIps1": "Li e concordo com a <a :href=\"policyUrl\">\"Política de Privacidade\"</a>, <a :href=\"serviceURl\">\"Termos de Serviço\"</a> e <a :href=\" paymentURl\">\"Condições de Pagamento\"</a>.",
    "checkTIps2": "Por favor leia e marque a caixa de seleção",
    "selectTips": "(A moeda da compra mais recente será selecionada)",
    "koPayTips": "Se o seu cartão bancário usar Won Coreano como moeda estrangeira, o serviço de Conversão Dinâmica de Moeda (DCC) será usado, e uma taxa de manuseio adicional poderá ser cobrada por um proxy de terceiros e não por este site.",
    "PayTips": ""
  },
  "invoice": {
    "title": "recibo",
    "transactionId": "ID da Transação",
    "transactionDate": "Data da Transação",
    "totalAmount": "Montante Total",
    "paymentMethod": "Forma de Pagamento",
    "description": "Descrição",
    "game": "Jogo",
    "quantity": "Quantidade",
    "price": "Preço",
    "amount": "Quantidade",
    "total": "Montante Total",
    "footTitle": "Notas",
    "footContent": "Obrigado por apoiar a Century Games!",
    "button1": "Obter o Recibo",
    "button2": "Voltar sem o Recibo",
    "giveupInvoice": "Você não vai receber o recibo do pedido. Confirmar?"
  },
  "payment": {
    "card": "Cartão de Crédito / Cartão de Débito",
    "paypal": "PayPal"
  },
  "country": {
    "countryTitle1": "PAÍS / REGIÃO",
    "Africa": "África",
    "America": "América",
    "Asia": "Ásia",
    "Europe": "Europa",
    "Oceania": "Oceânia",
    "ZA": "África do Sul",
    "US": "Estados Unidos",
    "HK": "Hong Kong, China",
    "JP": "Japão",
    "KR": "Coréia",
    "SG": "Cingapura",
    "SA": "Arábia Saudita",
    "IQ": "Iraque",
    "TW": "Taiwan, China",
    "TH": "Tailândia",
    "GB": "Reino Unido",
    "AU": "Austrália",
    "countryLanguage1": "IDIOMA",
    "AE": "Emirados Árabes Unidos",
    "DE": "Alemanha",
    "PT": "Portugal",
    "RU": "Rússia",
    "ES": "Espanha",
    "CH": "Suíça",
    "TR": "Peru",
    "KW": "Kuwait",
    "QA": "Catar",
    "PL": "Polônia",
    "ID": "Indonésia",
    "IT": "Itália",
    "IN": "Índia",
    "FR": "França",
    "CA": "Canadá",
    "NL": "Holanda",
    "AT": "Áustria",
    "RS": "Sérvia",
    "SE": "Suécia",
    "MY": "Malásia",
    "BE": "Bélgica",
    "DK": "Dinamarca",
    "FI": "Finlândia",
    "PH": "Filipinas",
    "NO": "Noruega",
    "BR": "Brasil",
    "NZ": "Nova Zelândia",
    "UA": "Ucrânia",
    "RO": "Romênia"
  },
  "extra_info": {
    "kingdom": "Estado: #"
  },
  "adyen": {
    "note": "O serviço de pagamento é fornecido pela Adyen, oferecendo transações seguras com o mais alto nível de certificação PCI-DSS das organizações internacionais de cartão de crédito que suportam pagamentos com cartão nacionais e internacionais.",
    "note2": "Observação: Marque \"Salvar para meu próximo Pagamento\" para salvar as informações do seu cartão de pagamento dentro do navegador atual para fazer pagamentos futuros."
  },
  "pay": {
    "error1": "Se algo der errado, tente novamente mais tarde ou use outro método de pagamento. Entre em contato com o suporte ao cliente se tiver mais dúvidas."
  },
  "meta": {
    "title": "Loja do Family Farm Adventure",
    "description": "A Loja do Family Farm Adventure é a loja oficial, oferecendo um canal de recarga com desconto e pacotes do jogo para os jogadores.",
    "keywords": "fazenda, cultivo, mercado, atualização, exploração, mapa, personagem, nível, simulação, estratégia, pagamento, loja, recarga, pagamento"
  }
};


// WEBPACK FOOTER //
// ./src/lang/PT.js